import FeathersHelper from "../../helpers/feathers";

export const find = payload => FeathersHelper.app.service('apps').find(payload);
export const create = (payload) =>
  FeathersHelper.app.service("apps").create(payload);
export const patch = (id, payload, params = {}) =>
         FeathersHelper.app.service("apps").patch(id, payload, params);
